import request from '@/utils/request';

// 编辑个人信息
export function editPersonalInformation(data) {
  return request.post('admin/user/edit-personal-information', data);
}
// 验证手机号验证码
export function checkMobileCode(data) {
  return request.post('admin/user/check-mobile-code', data);
}